module.exports = __webpack_public_path__ + "static/media/het_OJx1EdNy2.bf97b89e.jpeg";